import Photo from './Photo';
import Mark from './Mark';

/** A photo in an arched window with concentric outlines, like a doorway. */
export default function Arch({ src, alt = '', tone = 'light', eager = false, position, className = '' }) {
  return (
    <div className={`arch arch--${tone} ${className}`}>
      <div className="arch-inner">
        {src
          ? <Photo src={src} alt={alt} eager={eager} position={position} fallback />
          : <span className="photo-fallback"><Mark /></span>}
      </div>
    </div>
  );
}
